angular.module("tasks_status")

    .controller("TasksStatusListCtrl", ['LoginService', '$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', '$filter', '$state', function (LoginService, $rootScope, $scope, Restangular, gridService, modalService,  $filter,  $state) {

        //Comprobamos si tiene permiso escritura
         $scope.allowWrite = LoginService.permissionExist("TASKS_STATUS_WRITE");

        $rootScope.title = $filter('translate')('tasks_status.title');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('tasks_status.title') }
        ];

        $scope.selectEntityTypes = [{ id: null, name: $filter("translate")('entity_types.all') }, { id: 'events', name: $filter("translate")('entity_types.events') }, { id: 'correspondence', name: $filter("translate")('entity_types.correspondence') }, { id: 'general', name: $filter("translate")('entity_types.general') }];
        $scope.search = { entity_type: null };
        $scope.gridOptionsTasksStatus = {
            pdfTitle: $filter('translate')('tasks_status.pdf_title'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            enableSorting: true,             
            paginationPageSizes: [20, 40, 60],
            paginationPageSize: 20,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
                { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                { name: 'entity_type', displayName: $filter('translate')('tasks_status.entity_type'), cellTemplate: gridService.entityTypeTemplate('entity_type'), enableFiltering: false, enableHiding: false, width: 120 },
                { name: 'name', displayName: $filter('translate')('tasks_status.name'), enableFiltering: true, enableHiding: false },
                { name: 'is_initial', displayName: $filter('translate')('tasks_status.is_initial'), cellTemplate: gridService.yesNoTemplate('is_initial'), enableFiltering: false, enableHiding: true, width: 100 },
                { name: 'is_final', displayName: $filter('translate')('tasks_status.is_final'), cellTemplate: gridService.yesNoTemplate('is_final'), enableFiltering: false, enableHiding: true, width: 100 },
              {
                  name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                      { title: $filter('translate')('tasks_status.button_edit'), action: 'ui-sref="tasks_status.edit({id:row.entity.id})"', cssClass: "btn btn-xs btn-default btn-outline btn-custom-laptop", cssIconClass: "fa fa-edit" },
                      { title: $filter('translate')('tasks_status.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssClass: "btn btn-xs btn-default btn-outline btn-custom-laptop", cssIconClass: "fa fa-remove" }
                  ], { cssClass: "pull-right" })
              },
            ],
            getData: function (options) {
                options.entity_type = $scope.search.entity_type;
                return Restangular.all('TasksStatus').getList(options);
            }
        };

        $scope.goToEdit = function (rowEntity) {
            $state.go("tasks_status.edit", { id: rowEntity.id });
        }

        $scope.loadData = function () {
            $scope.gridOptionsTasksStatus.loadData(false);
        }

        $scope.deleteDialog = function (id, name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter('translate')('tasks_status.button_delete'),
                message: $filter('translate')('tasks_status.delete_message') + " " + $scope.name + "?",
                onAccept: function () {
                    Restangular.one('TasksStatus', $scope.id).remove().then(function () {
                        toastr.success($filter('translate')('tasks_status.deleted_success'));
                        $scope.gridOptionsTasksStatus.gridApi.core.raise.itemDeleted($scope);
                        
                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });

        };
        
    }])

;